import * as React from 'react';

import { generateGUID } from '@common/react/utils/utils';

interface CaptchaProps {
	update: any;
	withGuid?: boolean;
	iconClassName?: string;
	counter?: number;
	path?: string;
}

const Captcha: React.FC<CaptchaProps> = (props) => {
	const {
		iconClassName = 'icon-refresh icons',
		update,
		withGuid = true,
		counter,
		path = 'captcha',
	} = props;

	const getSrc = (): string => {
		return `${path}?${withGuid ? `guid=${code}` : 'id='}&refresh=${new Date().getTime()}`;
	};

	const [code, setCode] = React.useState(() => generateGUID());
	const [src, setSrc] = React.useState(getSrc());
	const [currentCounter, setCurrentCounter] = React.useState(counter);

	const reload = (event: any) => {
		event.preventDefault();
		setSrc(getSrc());
	};

	React.useEffect(() => {
		update(code);
	}, []);

	React.useEffect(() => {
		if (counter !== currentCounter) {
			setCurrentCounter(counter);
			setSrc(getSrc());
		}
	}, [counter]);

	return <div className="captcha-component">
		<img src={src} alt="captcha" />
		<button className="captcha-component__reload" tabIndex={-1} type="button" onClick={reload}>
			<i className={`captcha-component__icon ${iconClassName}`} />
		</button>
	</div>;
};

export default Captcha;
